import React, { createContext, type ReactNode, useContext } from 'react'
import preferenceKeys from '../person-page/preference-keys'
import type { ProviderValue } from './PreferenceProvider'
import PreferenceProvider from './PreferenceProvider'

const defaultHintLevel = {
  recordHintLevel: 4,
}

type RecordHintLevelPrefOptions = Partial<typeof defaultHintLevel>
type RecordHintLevelPrefValue = ProviderValue<RecordHintLevelPrefOptions>

const RecordHintLevelPrefContext = createContext<RecordHintLevelPrefValue>([defaultHintLevel, () => undefined])

export function useRecordHintLevelPref(): RecordHintLevelPrefValue {
  return useContext(RecordHintLevelPrefContext)
}
type Props = {
  children: ReactNode
  loadingComponent: ReactNode
}

export default function RecordHintLevelPrefProvider({ children, loadingComponent }: Props): JSX.Element {
  return (
    <PreferenceProvider
      preferenceKey={preferenceKeys.MATCH_SERVICE}
      Context={RecordHintLevelPrefContext}
      loadingComponent={loadingComponent}
      defaultValue={defaultHintLevel}
    >
      {children}
    </PreferenceProvider>
  )
}
